import React from 'react';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import InspectionResultsContainer from 'components/inspection_result/index_container';
import ShowQuery from 'queries/inspection/show';
import ShowItem from 'components/inspection/show_item';
import TopMenu from 'components/layout/top_menu';
import LoaderContainer from 'components/layout/loader_container';
import { useQuery } from '@apollo/client/react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { PaginateProvider } from 'contexts/paginate';
import { InspectionsLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { WhiteCard } from 'components/styles_components/card';
import { CardOptionTypography } from 'components/styles_components/typography';
import { Grid } from 'components/ui';

const Inspection = () => {
  const setError = useError();
  const navigate = useNavigate();
  const { inspectionId } = useParams();
  const {
    data = { inspection: { inspectionFields: [] }, space: {} },
    loading,
    error,
    refetch,
  } = useQuery(ShowQuery, {
    variables: { id: inspectionId },
    onError: () => {
      setError('error.inspection.show');
      navigate(InspectionsLink());
    },
  });
  
  return (
    <>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbLink to={InspectionsLink()}>
            <FormattedMessage id="breadcrumb.inspections.index" />
          </BreadCrumbLink>
          <BreadCrumbTypography>{data.inspection.name}</BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <LoaderContainer loading={loading} error={error}>
        <ShowItem 
          inspection={data.inspection} 
          space={data.space} 
          refetch={refetch} 
          leftColumChildren={
            <Grid item size={{ xs: 12 }} sx={{ mt: 2 }}>
              <WhiteCard>
                <CardOptionTypography>
                  <FormattedMessage id="inspection.results.history" />
                </CardOptionTypography>
                <PaginateProvider key="inspection-results-history">
                  <InspectionResultsContainer inspectionId={inspectionId} />
                </PaginateProvider>
              </WhiteCard>
            </Grid>
          }
          />
      </LoaderContainer>
    </>
  );
};

export default Inspection;
